import { useParams } from 'react-router-dom';
import { createRoute, useEntityUrl } from 'framework/routing';

const JOURNAL_ENTRY_PATH = '/journal-entry';
const COPY_SEGMENT = 'copy';
const REVERSE_SEGMENT = 'reverse';
const TRANSFER_SEGMENT = 'transfer';
const UPLOAD_JOURNAL_ENTRY_SEGMENT = 'upload-journal-entry';

export const getJournalEntryListUrl = () => JOURNAL_ENTRY_PATH;

export const getJournalEntryRouterPath = () => `${JOURNAL_ENTRY_PATH}/*`;

export const useJournalEntryRoute = () => {
  const routers = createRoute({ listRoute: JOURNAL_ENTRY_PATH });

  return {
    ...routers,
    copyEntityRoute: `${routers.singleEntityRoute}/${COPY_SEGMENT}`,
    reverseEntityRoute: `${routers.singleEntityRoute}/${REVERSE_SEGMENT}`,
    journalEntryByTransferRoute: `${routers.listRoute}/${TRANSFER_SEGMENT}/:transferId`,
    uploadJournalEntryRoute: `${routers.listRoute}/${UPLOAD_JOURNAL_ENTRY_SEGMENT}`,
  };
};

export const useJournalEntryUrl = () => {
  const baseUrls = useEntityUrl({ baseLink: JOURNAL_ENTRY_PATH });

  return {
    ...baseUrls,
    getCopyEntityUrl: (id?: string): string => `${baseUrls.getSingleEntityUrl(id)}/${COPY_SEGMENT}`,
    getReverseEntityUrl: (id?: string): string => `${baseUrls.getSingleEntityUrl(id)}/${REVERSE_SEGMENT}`,
    getJournalEntryByTransferUrl: (id?: string): string => `${baseUrls.getListUrl()}/${TRANSFER_SEGMENT}/${id}`,
    getUploadJournalEntryUrl: (): string => `${baseUrls.getListUrl()}/${UPLOAD_JOURNAL_ENTRY_SEGMENT}`,
  };
};

export const useJournalEntryId = () => useParams<Dictionary<string>>().id!;
export const useTransferId = () => useParams<Dictionary<string>>().transferId!;
